// src/components/layout/TopNavbar.jsx

import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import {
    FaBars,
    FaLeaf,
    FaBell,
    FaEnvelope
} from "react-icons/fa";

import SearchBar from "./SearchBar";
import UserMenu from "./UserMenu";

import { useAuth } from "../../context/AuthContext";

import LanguageSelector from "../language/LanguageSelector";

import "../../styles/TopNavbar.css";

export default function TopNavbar({

    onToggleDrawer

}) {

    //--------------------------------------------------------
    // Navigation
    //--------------------------------------------------------

    const navigate = useNavigate();
    const { t } = useTranslation();
    //--------------------------------------------------------
    // Authentification
    //--------------------------------------------------------

    const {

        user,

        isAuthenticated,

        logout

    } = useAuth();

    //--------------------------------------------------------
    // Déconnexion
    //--------------------------------------------------------

    const handleLogout = async () => {

        try {

            await logout();

            navigate("/login");

        }
        catch (e) {

            console.error(e);

        }

    };

    //--------------------------------------------------------

    return (

        <header className="top-navbar">

            {/*================================================*/}
            {/* Partie gauche                                  */}
            {/*================================================*/}

            <div className="top-navbar-left">

                <button

                    className="drawer-button"

                    onClick={onToggleDrawer}

                >

                    <FaBars />

                </button>

                <Link

                    to="/"

                    className="navbar-brand-custom"

                >

                    <FaLeaf className="brand-icon" />

                    <span>

                        FelahLink

                    </span>

                </Link>

            </div>

            {/*================================================*/}
            {/* Centre                                          */}
            {/*================================================*/}

            <div className="top-navbar-center">

                <SearchBar />

            </div>

            {/*================================================*/}
            {/* Partie droite                                   */}
            {/*================================================*/}

            <div className="top-navbar-right">

                {/*============================================*/}
                {/* Sélecteur de langue                         */}
                {/*============================================*/}

                <div className="me-3">

                    <LanguageSelector />

                </div>

                {

                    isAuthenticated

                    ?

                    <>

                        <button

                            className="top-icon-button"

                            title={t("navbar.notifications")}

                        >

                            <FaBell />

                        </button>

   <button
    className="top-icon-button"
    title={t("navbar.messages")}
>
    <FaEnvelope />
</button>

                        <UserMenu

                            user={user}

                            onLogout={handleLogout}

                        />

                    </>

                    :

                    <>

                        <Link

                            to="/login"

                            className="btn btn-success me-2"

                        >

                             {t("connexion.login")}

                        </Link>

                        <Link

                            to="/register"

                            className="btn btn-outline-success"

                        >

                            {t("connexion.createAccount")}


                        </Link>

                    </>

                }

            </div>

        </header>

    );

}